// Internal
// --------

const defaultValues = {
  country_code: 'US',
  phone_number: '0000000000',
  spells: '',
  page: ''
};

// Exports
// -------

export {
  defaultValues
};

/**
 * Returns a default value for a field if one exists.
 *
 * @param {string} fieldName
 * @param {string} [defaultValue=undefined]
 */
export default function getDefaultValue(fieldName, defaultValue = undefined) {
  const value = defaultValues[fieldName];
  return value === undefined ? defaultValue : value;
}



// WEBPACK FOOTER //
// ./client/app/scripts/leadform/constants/default_values.js